import { Component, Input, ViewEncapsulation } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { EmailMarginComponent } from '../email-margin/email-margin.component';

@Component({
  selector: 'email-layout',
  templateUrl: './email-layout.component.html',
  styleUrls: ['./email-layout.component.less'],
  imports: [EmailMarginComponent],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EmailLayoutComponent {
  @Input() public showLogo: boolean = true;
}
